export default "__VITE_ASSET__1grsQn6t__"